<mbsc-popup
  #popup
  [anchor]="popupAnchor"
  [contentPadding]="false"
  [scrollLock]="false"
  [showOverlay]="false"
  [touchUi]="false"
  [width]="350"
  class="mds-tooltip"
  display="anchored"
>
  <div *ngIf="event" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="mbsc-padding">

      <div class="info-icons-container">
        <span *ngIf="event.category" class="info-badge" [ngStyle]="{ 'background-color': colorService.getCategoryColor(event.category) }">{{event.category}}</span>
        <span class="info-badge" [ngStyle]="{ 'background-color': colorService.getStatusColor(event) }">{{ getEventStatus(event) }}</span>
        
        <img src="https://assets.tridimo.de/fontawesome/svgs/regular/wifi.svg" alt="Onlinetermin" *ngIf="event.online" title="Onlinetermin" [ngStyle]="{ 'background-color': iconService.getIconBackground(event, 'online')}">
        <img src="https://assets.tridimo.de/fontawesome/svgs/regular/folder-open.svg" alt="Vorbereitungsmaterial" *ngIf="event.vorbereitungsmaterial === '1' || event.vorbereitungsmaterial === true" title="Vorbereitungsmaterial" [ngStyle]="{ 'background-color': iconService.getPrepIconBackground(event)}">
        <img src="https://assets.tridimo.de/fontawesome/svgs/regular/user.svg" alt="Fehlender Dolmetscher" *ngIf="this.missing" title="Fehlender Dolmetscher" [ngStyle]="{ 'background-color': iconService.getIconBackground(event, 'interpretor')}">
        <img src="https://assets.tridimo.de/fontawesome/svgs/regular/user-plus.svg" alt="Zuviele Dolmetscher" *ngIf="this.overload" title="Zuviele Dolmetscher" [ngStyle]="{ 'background-color': iconService.getIconBackground(event, 'overload')}">
        <img src="https://assets.tridimo.de/fontawesome/svgs/regular/map-location-dot.svg" alt="Adresse fehlt" *ngIf="!event.online && ['MISSIONEVENT', 'TEAMEVENT', 'MEETINGEVENT', 'NOTBILLABLEEVENT'].includes(event.type)" title="Adresse" [ngStyle]="{ 'background-color': iconService.getIconBackground(event, 'location')}">
        <img src="https://assets.tridimo.de/fontawesome/svgs/regular/circle-quarter-stroke.svg" alt="" *ngIf="event.dialinTime" title="Einwahlzeit">
        <img src="https://assets.tridimo.de/fontawesome/svgs/regular/timer.svg" alt="" *ngIf="event.dialinTime" title="Minutengenau">  
          
        <div class="informations-container" *ngIf="event.informations as infos">
          <ng-container *ngFor="let icon of (infos || [])">
            <div *ngIf="icon.icon_name !== 'fremd Dolmetscher'" class="information-icon">
              <img   [src]="iconService.getIconUrl(icon.icon_name)" 
                   [title]="
                     icon.type === 'checkbox' && icon.info ? icon.title + ': ' + icon.info :
                     icon.type === 'select'   && icon.value ? icon.title + ': ' + icon.value :
                     icon.type === 'radio'    && icon.value ? icon.title :
                     ''">
            </div>
          </ng-container>
        </div>
      </div>

      <span class="mds-tooltip-label mbsc-margin title">{{ event.title }}</span>
      <div *ngIf="hasValidCustomer(event) && event.type === 'MISSIONEVENT'" class="mds-tooltip-label mbsc-margin">Kunde: {{getCustomerNames(event)}}</div>
      <div class="mds-tooltip-label ticketno-container" *ngIf="event.ticketno && event.ticketno !== '0'"><span>Ticket: </span>
        <a href="https://app.hubspot.com/contacts/9038082/record/0-5/{{event.ticketno}}/" target="_blank">{{event.ticketno}}</a>
        <mbsc-button class="copy-button" (click)="copyToClipboard(event.ticketno)">
          <img loading="lazy" src="./assets/icons/copy_black.png" alt="" srcset="">
        </mbsc-button>
        <span *ngIf="isCopied" class="copied-message">Nummer kopiert!</span>
      </div>

      <div class="mds-tooltip-label mbsc-margin">Uhrzeit: {{this.formattedStart}} - {{this.formattedEnd}} Uhr</div>

      <div class="mds-tooltip-label mbsc-margin" *ngIf="event.location">Ort: 
        <a *ngIf="event.location !== 'Online'" href="https://www.google.com/maps?q={{event.location}}" target="_blank">{{event.location}}</a>
        <span *ngIf="event.location === 'Online'">{{event.location}}</span>
      </div>

      <div class="mds-tooltip-label mbsc-margin" *ngIf="event.description">Beschreibung: <span class="mbsc-light description"><p>{{event.description}}</p></span></div>
    
      <div *ngIf="event.online === 1 && event.onlineLink.length > 0" class="mds-tooltip-label mbsc-margin">Eventlink:  
        <div *ngFor="let item of event.onlineLink || []" class="eventlink-container">
          <img *ngIf="item.platform !== 'online' && item.platform !== 'Link'  && item.platform !== 'Keine Plattform'" [src]="platformIcons[item.platform]" alt="{{ item.platform }}" title="{{ item.platform }}" class="platform-icon" />
          <span *ngIf="item.platform === 'online'">Online</span>
          <a *ngIf="item.link !== ''" [href]="item.link" [title]="item.link">Beitreten</a>
          <span *ngIf="item.link === '' && item.platform !== 'online' && item.platform !== 'apple' && item.platform !== 'Keine Plattform' && item.platform !== 'studio' "class="link-missing">fehlender Link</span>
        </div>

        <!-- <a href="http://{{event.onlineLink}}">{{event.onlineLink}}</a>  -->
        <!-- <span [ngClass]="event.online === 1 && event.onlineLink === '' ? '' : 'hide'" class="link-missing">fehlt</span> -->
      </div>

      <div *ngIf="event.vorbereitungsmaterial === '1'" class="mds-tooltip-label mbsc-margin">Materiallink: 
        <a  target="_blank"  [href]="event.vorbereitungsmaterialLink">{{event.vorbereitungsmaterialLink}}</a>
        <!-- <div (click)="openLink(event.vorbereitungsmaterialLink)" >Link öffnen</div> -->
        <span [ngClass]="event.vorbereitungsmaterial === '1' && event.vorbereitungsmaterialLink === '' ? '' : 'hide'" class="link-missing">fehlt</span>
      </div>

      @if (event.vorbereitungZeit) {
        <div class="mbsc-margin">Vorbereitungszeit: {{event.vorbereitungZeit}} Minuten</div>
      }

      @if (event.aufzeichnung) {
        <div class="mbsc-margin">Aufzeichnung: Ja</div>
      }

      <div class="interpreter-container">
        <div class="mds-tooltip-label">Dolmetscher:</div>
        <div style="display: flex; overflow-x: auto; gap: 4px">
          <!-- <div *ngFor="let int of intData" class="mini-user-icon" [ngClass]="int.workingType === 'Praktikant' ? 'trainee-mini-icon-color' : ''"> -->
            <!-- <span *ngIf="int.workingType !== 'Praktikant'">{{int.cr}}</span> -->
            <!-- <span *ngIf="int.workingType === 'Praktikant'">P</span> -->
          <!-- </div> -->
           <div class="cr-container">
                    <ng-container *ngFor="let co of intData || []">
                      <div
                        *ngIf="co.workingType !== 'Allgemein'"
                        class="mini-user-icon"
                        [ngClass]="co.workingType === 'Praktikant' ? 'trainee-mini-icon-color' : ''"
                      >
                        <span *ngIf="co.workingType !== 'Praktikant'">{{ co.cr }}</span>
                        <span *ngIf="co.workingType === 'Praktikant'">P</span>
                      </div>
                    </ng-container>

                    <div *ngIf="fremdData" class="mini-fremd-icon">
                      <span>F</span>
                    </div>
                </div>
        </div>       
        <!-- <div [ngClass]="checkForMissingInterpreters() ? 'missing-icon' : 'hide'">
          <span>+{{this.missingNumber}}</span>
        </div> -->
        <!-- TESTEN -->
        <div [ngClass]="missing ? 'missing-icon' : 'hide'">
          <span *ngIf="missing">+{{ missingNumber }}</span>
        </div>

      </div>

      <div class="interpreter-container">
        <div *ngIf="fremdData" class="mds-tooltip-label">Fremd-Dolmetscher:</div>
        <div style="display: flex; overflow-x: auto; gap: 4px">
          <div *ngFor="let fremd of fremdData; let i = index">
            @if (fremd.name !== '') {
              <span>{{fremd.name}}</span>
              <span *ngIf="i < fremdData.length - 1">, </span>
            }

          </div>
          @if (this.getMissingFremdDolmetscher(event)) {
            <div class="missing-int-badge" [title]="'Fehlende Fremd Dolmetscher: ' + this.getMissingFremdDolmetscher(event)">
              <span>{{this.getMissingFremdDolmetscher(event)}}</span>
            </div>
          }
        </div>       
      </div>
    <div class="event-id"> ID: {{ event.id }} </div>
    </div>
  </div>
</mbsc-popup>

